import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(survey: any) {
    return this.http.post(this.configurations.apiAddress + "/api/Survey/save", survey);
  }

  saveSurveyResult(surveyResult: any) {
    return this.http.post(this.configurations.apiAddress + "/api/Survey/addSurveyResult", surveyResult);
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/Survey/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Survey/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/Survey/getAll/');
  }

  search(searchText: string) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
    return this.http.get(this.configurations.apiAddress + '/api/Survey/getAll', { params: myParams });
  }

  applySurvey(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Survey/applySurvey/' + id);
  }

  getSurveyResultDetails(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Survey/getSurveyResultDetails/' + id);
  }
}
